export const className = (...args) => args.filter(Boolean).join(" ") || null
